import de from "./de.json" with { type: "json" };
import en from "./en.json" with { type: "json" };
import es from "./es.json" with { type: "json" };
import fr from "./fr.json" with { type: "json" };

export type LocaleCode = "de" | "en" | "es" | "fr";

export type Locale = typeof de;

export const locales: Record<LocaleCode, Locale> = { de, en, es, fr } as Record<LocaleCode, Locale>;

export const LOCALE_CODES: LocaleCode[] = ["de", "en", "es", "fr"];

export function getLocale(code: LocaleCode): Locale {
  return locales[code] ?? locales.de;
}
